import { ConsentCategory } from "@amzn/client-workbench-api-model";
import { AxiosError } from "axios";
import { useMutation, UseMutationResult } from "react-query";

import {
  submitUserConsentV2,
  UpdateUserConsentV2ResponseSchema,
} from "@/apis/UserConsentsV2Helper";
import { getRetryDelayMs, shouldRetry } from "@/helpers/react-query-helper";

interface SubmitUserConsentV2Variables {
  consentCategory: ConsentCategory;
  consentGranted: boolean;
  termsVersion?: string;
}

/**
 * Custom hook to invoke the API call to store user consent (v2) in the DDB.
 * This hook supports different consent categories.
 */
export const useSubmitUserConsentV2 = (): UseMutationResult<
  UpdateUserConsentV2ResponseSchema,
  AxiosError,
  SubmitUserConsentV2Variables
> => {
  return useMutation<
    UpdateUserConsentV2ResponseSchema,
    AxiosError,
    SubmitUserConsentV2Variables
  >(
    "submitUserConsentV2",
    ({ consentCategory, consentGranted, termsVersion }) =>
      submitUserConsentV2(consentCategory, consentGranted, termsVersion),
    {
      /**
       * By default, React Query will not retry a mutation on error. Only retry on Axios errors with a transient error
       * code if the failure count is within the retry limit.
       */
      retry: shouldRetry,
      retryDelay: getRetryDelayMs,
    }
  );
};
